'use client'

import { useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import { Suspense } from 'react'

function LoginForm() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const redirect = searchParams.get('redirect') || '/'

  const [isLogin, setIsLogin] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const method = isLogin ? 'POST' : 'PUT'
      const body = isLogin
        ? { email, password }
        : { email, password, name }

      const res = await fetch('/api/auth', {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })

      const data = await res.json()

      if (!res.ok) {
        setError(data.error || 'Произошла ошибка')
        return
      }

      // Перенаправляем на исходную страницу или на главную
      router.push(redirect)
    } catch {
      setError('Ошибка соединения с сервером')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #8B5A2B 0%, #5D4037 50%, #3E2723 100%)',
      }}
    >
      <div
        className="w-full max-w-md p-8"
        style={{
          background: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(16px)',
          borderRadius: '14px',
          border: '1px solid rgba(139, 90, 43, 0.2)',
          boxShadow: '0 12px 40px rgba(139, 90, 43, 0.15), 0 4px 12px rgba(0, 0, 0, 0.08)',
        }}
      >
        {/* Логотип */}
        <div className="text-center mb-6">
          <img
            src="/logo-podkova.svg"
            alt="Подкова"
            style={{ width: 64, height: 64, margin: '0 auto 12px' }}
          />
          <h1 className="text-2xl font-bold" style={{ color: '#3E2723' }}>
            Подкова
          </h1>
          <p style={{ color: '#999', fontSize: '13px', marginTop: 4 }}>
            {isLogin ? 'Войдите в свой аккаунт' : 'Создайте новый аккаунт'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: '#5D4037' }}>
                Имя
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full outline-none transition"
                style={{
                  padding: '8px 12px',
                  fontSize: '13px',
                  border: '1px solid rgba(139, 90, 43, 0.3)',
                  borderRadius: '8px',
                  background: '#fff',
                  color: '#3E2723',
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = '#5D4037'
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(139, 90, 43, 0.3)'
                }}
                placeholder="Введите ваше имя"
                required={!isLogin}
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#5D4037' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full outline-none transition"
              style={{
                padding: '8px 12px',
                fontSize: '13px',
                border: '1px solid rgba(139, 90, 43, 0.3)',
                borderRadius: '8px',
                background: '#fff',
                color: '#3E2723',
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = '#5D4037'
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = 'rgba(139, 90, 43, 0.3)'
              }}
              placeholder="Введите email"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#5D4037' }}>
              Пароль
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full outline-none transition"
                style={{
                  padding: '8px 36px 8px 12px',
                  fontSize: '13px',
                  border: '1px solid rgba(139, 90, 43, 0.3)',
                  borderRadius: '8px',
                  background: '#fff',
                  color: '#3E2723',
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = '#5D4037'
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(139, 90, 43, 0.3)'
                }}
                placeholder="Введите пароль"
                required
                minLength={6}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '2px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#999',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#5D4037'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#999'
                }}
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div className="text-sm text-center py-2" style={{ color: '#e53e3e' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full text-white font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              background: '#2E8B57',
              borderRadius: '8px',
              padding: '10px 12px',
              fontSize: '14px',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
            onMouseEnter={(e) => {
              if (!loading) e.currentTarget.style.background = '#247A4A'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#2E8B57'
            }}
          >
            {loading ? 'Загрузка...' : (isLogin ? 'Войти' : 'Зарегистрироваться')}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => {
              setIsLogin(!isLogin)
              setError('')
            }}
            className="text-sm transition-colors"
            style={{ color: '#5D4037' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#3E2723'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#5D4037'
            }}
          >
            {isLogin
              ? 'Нет аккаунта? Зарегистрироваться'
              : 'Уже есть аккаунт? Войти'}
          </button>
        </div>

        {/* Ссылка на Task Manager */}
        <div
          className="mt-6 pt-6 text-center"
          style={{ borderTop: '1px solid rgba(139, 90, 43, 0.1)' }}
        >
          <a
            href={process.env.NEXT_PUBLIC_TASKS_URL || 'https://tasks.komandapodkova.ru'}
            className="text-sm transition-colors"
            style={{ color: '#999' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#5D4037'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#999'
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline', verticalAlign: 'middle', marginRight: '4px' }}>
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
            </svg>
            Перейти в Task Manager
          </a>
        </div>
      </div>
    </div>
  )
}

export default function LoginPage() {
  return (
    <Suspense fallback={
      <div
        className="min-h-screen flex items-center justify-center"
        style={{
          background: 'linear-gradient(135deg, #8B5A2B 0%, #5D4037 50%, #3E2723 100%)',
        }}
      >
        <div style={{ color: '#fff', fontSize: '14px' }}>Загрузка...</div>
      </div>
    }>
      <LoginForm />
    </Suspense>
  )
}
